import * as React from 'react';
import Page from './page';
import { controller as ScopeController } from './scope';

import setting from '../../setting';

export default function ({ pages, active, pageSize, viewSize, scopeCtl }: {
    pages: string[],
    active: number,
    pageSize: size,
    viewSize: size,
    scopeCtl: ScopeController,
}) {
    const style: React.CSSProperties = {
        display: 'flex',
        width: `${pageSize.width * pages.length}px`,
        position: 'absolute',
        left: `${active * pageSize.width * -1}px`,
        transition: 'left 0.2s ease-out',
    }
    return (
    <div style={style}>
        {(() => {
            return pages
            .map(page => <Page
                path={`${setting.bookDir}/pages/${page}`}
                onDrag={offset => scopeCtl.applyOffsetDelta(offset)}
                onWheel={e => {
                    const scaleW = viewSize.width / pageSize.width;
                    const scaleH = viewSize.height / pageSize.height;
                    scopeCtl.applyScaleDelta(e.deltaY < 0 ? 0.2 : -0.2, {
                        x: e.clientX * scaleW,
                        y: e.clientY * scaleH,
                    });
                }}
            />)
        })()}
    </div>);
}

type size = {
    width: number,
    height: number,
}
